import styled from 'styled-components';

const ItemWrapper = styled.g``;

export { ItemWrapper };
